import React from 'react';
import useReveal from '../hooks/useReveal';

const areas = [
  {
    category: 'Sicurezza Endpoint & XDR',
    description:
      'Proteggiamo ogni dispositivo aziendale con soluzioni di rilevamento e risposta alle minacce di ultima generazione. EDR, XDR e threat intelligence in tempo reale per bloccare attacchi avanzati prima che causino danni.',
    partners: ['CrowdStrike', 'SentinelOne', 'Sophos']
  },
  {
    category: 'Network Security & Firewall',
    description:
      'Progettiamo e gestiamo perimetri di sicurezza rinforzati: firewall next-generation, segmentazione della rete, VPN aziendali e protezione da intrusioni per ambienti distribuiti e ibridi.',
    partners: ['Fortinet', 'SonicWall', 'Netskope']
  },
  {
    category: 'Cloud & Storage',
    description:
      'Accompagniamo le aziende nella migrazione e nella gestione di ambienti cloud enterprise, con soluzioni di storage scalabili, ad alta disponibilit\u00e0 e a costi ottimizzati.',
    partners: ['Azure', 'Wasabi']
  },
  {
    category: 'Infrastrutture & Virtualizzazione',
    description:
      'Progettiamo data center moderni, ambienti virtualizzati e infrastrutture iperconvergenti. Dalla scelta dell\u2019hardware al collaudo finale, ogni componente \u00e8 selezionato per durabilit\u00e0 e performance.',
    partners: ['Dell', 'VMware', 'Proxmox', 'HyperV']
  },
  {
    category: 'Backup & Disaster Recovery',
    description:
      'Garantiamo la continuit\u00e0 operativa con strategie di backup multi-livello e piani di disaster recovery testati. I vostri dati sono sempre al sicuro, recuperabili in tempi certi.',
    partners: ['Veeam', 'Wasabi']
  },
  {
    category: 'Identity & Access Management',
    description:
      'Controlliamo chi accede a cosa, quando e da dove. Zero Trust, autenticazione multi-fattore e governance delle identit\u00e0 per eliminare i rischi legati agli accessi non autorizzati.',
    partners: ['Okta', 'Microsoft']
  },
  {
    category: 'Email Security',
    description:
      'L\u2019email \u00e8 il vettore di attacco pi\u00f9 sfruttato dai cybercriminali. Filtriamo phishing, malware, spam e attacchi BEC in ingresso e in uscita, proteggendo ogni mailbox aziendale.',
    partners: ['Libraesva', 'Microsoft']
  },
  {
    category: 'Security Awareness',
    description:
      'La tecnologia da sola non basta: il fattore umano \u00e8 spesso l\u2019anello pi\u00f9 debole. Formiamo il personale aziendale con percorsi di security awareness per riconoscere e prevenire le minacce pi\u00f9 comuni.',
    partners: ['CyberGuru']
  }
];

const TechAreas = () => {
  return (
    <section id="solutions" className="tech-areas-section">
      <div className="tech-areas-inner">
        <h2 className="section-title">Aree di competenza</h2>
        <p className="section-subtitle">
          Operiamo lungo tutto lo stack tecnologico aziendale, dai dispositivi degli utenti fino alle infrastrutture cloud,
          integrando le migliori soluzioni del mercato in un ecosistema coerente e gestito.
        </p>
        <div className="tech-areas-grid">
          {areas.map((area, idx) => {
            const [ref, visible] = useReveal();
            return (
              <div
                key={idx}
                ref={ref}
                className={`tech-area-card reveal${visible ? ' reveal-visible' : ''}`}
                style={{ transitionDelay: `${(idx % 4) * 0.1}s` }}
              >
                <h3 className="tech-area-title">{area.category}</h3>
                <p className="tech-area-desc">{area.description}</p>
                <div className="tech-area-partners">
                  {area.partners.map(p => (
                    <img
                      key={p}
                      src={`/assets/partners/${p}.png`}
                      alt={p}
                      className="tech-partner-logo"
                      title={p}
                    />
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TechAreas;
